import Service from '../../services'
import { checkAndReturn } from "../../main"
// import Service from "@/services";

const state = {
    formDetail: {},
    formApprovedCredit: {},
    formResult: {},
    formSuccessEvaluation: {},
    SummaryData: {},
}

const getters = {

}

const actions = {
    storeFundamental ({ commit }, data) {
        return Service.Fundamental.storeFundamental(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    updateFundamental ({ commit }, data) {
        return Service.Fundamental.updateFundamental(data.payload).then(res => {
            return checkAndReturn(data, res)
        })
    },

    deleteFundamental ({ commit }, data) {
        return Service.Fundamental.deleteFundamental(data.payload).then(res => {
            return checkAndReturn(data, res, true)
        })
    },

    getFundamentalList ({ commit }, params) {
        return Service.Fundamental.getFundamentalList(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getEditMasterFundamental ({ commit }, params) {
        return Service.Fundamental.getEditMasterFundamental(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },

    getEditMasterFundamentalCreate ({ commit }, params) {
        return Service.Fundamental.getEditMasterFundamentalCreate(params.payload).then(res => {
            return checkAndReturn(params, res)
        })
    },


}

const mutations = {
    setDetailForm (state, val) {
        state.formDetail = val
    },
    setApprovedCreditForm (state, val) {
        state.formApprovedCredit = val
    },
    setResultForm (state, val) {
        state.formResult = val
    },
    setSuccessEvaluationForm (state, val) {
        state.formSuccessEvaluation = val
    },

    addSummaryData (state, val) {
        state.SummaryData = {
            ...state.SummaryData,
            ...val
        }
    },
    clearSummaryData (state) {
        state.SummaryData = {}
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
